import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'material-product-groups-navigation',
    templateUrl: './material-product-groups-navigation.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaterialProductGroupsNavigationComponent {
  @Output() openCreate: EventEmitter<void> = new EventEmitter<void>();

  constructor() {
  }
}
